<template>
    <div class="llp-textarea">
        <textarea :id="id" :class="[{'border border-danger' : errors.length > 0}, classNames]"
                  :disabled="disabled" :name="id"
                  :placeHolder="placeHolder" :rows="rows" :value="modelValue" class="form-control"
                  @input="$emit('update:modelValue', $event.target.value)">
        </textarea>
        <span v-if="errors.length === 1" class="text-danger">
            {{ errors[0].$message }}
        </span>
        <ul v-else-if="errors.length > 1" class="m-0">
            <li v-for="error in errors" :key="error.$uid" class="text-danger">
                <span class="text-danger">{{ error.$message }}</span>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'BaseTextarea',
  props: {
    id: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [String, Number, null],
      required: true,
    },
    classNames: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    rows: {
      type: Number,
      required: false,
      default: 3,
    },
    placeHolder: {
      type: String,
      required: false,
      default: '',
    },
    errors: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
};
</script>
